import { render } from "./IncomeStatement.vue?vue&type=template&id=43a39ff5&scoped=true"
import script from "./IncomeStatement.vue?vue&type=script&lang=js"
export * from "./IncomeStatement.vue?vue&type=script&lang=js"

import "./IncomeStatement.vue?vue&type=style&index=0&id=43a39ff5&scoped=true&lang=css"

import exportComponent from "/home/runner/work/origins-admin-v2/origins-admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43a39ff5"]])

export default __exports__